export default "__VITE_ASSET__e1e4adbb__"